import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  UPDATE_EMPLOYMENTS_SUCCESS,
  UPDATE_DECLARATION_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../actions/types'

const declaration = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.declaration || {}

    case UPDATE_EMPLOYMENTS_SUCCESS:
    case UPDATE_DECLARATION_FAILURE:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      return payload.declaration || state

    default:
      return state
  }
}

export default declaration;
